import React, { PureComponent } from 'react';

class ThemeHeader extends PureComponent {
    render() {
        return (
            <div
                className="ThemeHeaderWrapper"
                style={{
                    position: 'absolute',
                    top: '0',
                    width: '100%',
                    color: this.props.colors.secondary,
                    opacity: (this.props.showing ? '1' : '0'),
                    transform: 'translateY(' + (this.props.showing ? '0' : '-20px') + ')',
                    transition: 'opacity 200ms, transform 200ms',
                }}
            >
                <div
                    style={{
                        padding: '20px 25px',
                        textAlign: 'left',
                    }}
                >
                    <div
                        style={{
                            overflow: 'hidden',
                            display: 'inline-block',
                            color: '#fff',
                            borderRadius: '8px',
                            border: '1px solid ' + this.props.colors.secondary,
                        }}
                    >
                        <div
                            style={{
                                position: 'relative',
                                float: 'left',
                                padding: '4px 15px',
                                backgroundColor: this.props.colors.secondary,
                            }}
                        >
                            {this.props.level + 1}
                        </div>
                        <div
                            style={{
                                position: 'relative',
                                float: 'left',
                                padding: '4px 20px 4px 15px',
                                color: this.props.colors.secondary,
                                opacity: (this.props.showing ? '1' : '0'),
                            }}
                        >
                            {this.props.theme}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ThemeHeader;
